import { render, staticRenderFns } from "./ReferCompany.vue?vue&type=template&id=af5e359c&"
import script from "./ReferCompany.vue?vue&type=script&lang=ts&"
export * from "./ReferCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports